module.exports = __webpack_public_path__ + "front/img/icon07.842954ec.png";